module.exports = __webpack_public_path__ + "static/media/photo-u1.52728d55.jpg";